import { makeTintingRequest } from "../makeTintingRequest";

import { ColorCodeItemResponse } from "./getColorCode.typed";

export const getColorCode = async (colorCode: string) => {
  return await makeTintingRequest<ColorCodeItemResponse[]>({
    url: `/v1/colors/codes?code=${colorCode}&limit=10&offset=0`,
    method: "GET",
  });
};
